import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { PSPModuleFactory } from 'components/psp/PSPModuleFactory';
import { Container } from 'components/core/Page';

import './PSPSection.scss';
import { toKebabCase } from '../../../lib/helpers';

export default function PSPSection({ title, modules, background }) {
	// use a slugified version of the title as the id
	const sectionId = toKebabCase(title);
	return (
		<section
			className={classnames('psp-section', sectionId, background)}
			id={sectionId}
		>
			{modules.map((module, index) => (
				<Container
				// eslint-disable-next-line react/no-array-index-key
					key={`module-${index}`}
					className={`${module.type} ${module.id ? toKebabCase(module.id): ''}`}
				>
					<PSPModuleFactory
						type={module.type}
						props={module.props}
					/>
				</Container>
			))}
		</section>
	);
}

PSPSection.propTypes = {
	modules: PropTypes.arrayOf(PropTypes.object).isRequired,
	title: PropTypes.string.isRequired,
	background: PropTypes.string,
};
